import { jsx as _jsx } from "react/jsx-runtime";
import SwapVertIcon from '@material-ui/icons/SwapVert';
import SwapVertReverseIcon from '../../icons/SwapVertReverse';
import ActionBar from '../ActionBar/v2';
const MultiSelectFieldSortSelect = ({ sortMode, sortOption, onSelect, }) => {
    const selected = sortMode &&
        sortMode.by === sortOption.by &&
        sortMode.label === sortOption.label;
    const isReverted = selected
        ? sortMode.isReverseSort
        : sortOption.defaultDirection === 'desc';
    const sortLabel = sortOption && sortOption.label;
    if (!sortLabel) {
        return null;
    }
    return (_jsx(ActionBar.SelectOption, { label: sortLabel, icon: isReverted ? _jsx(SwapVertReverseIcon, {}) : _jsx(SwapVertIcon, {}), selected: selected, onClick: () => {
            onSelect({
                label: sortOption.label,
                by: sortOption.by,
                type: sortOption.type,
                isReverseSort: selected
                    ? !sortMode.isReverseSort
                    : sortOption.defaultDirection === 'desc',
            });
        } }));
};
export default MultiSelectFieldSortSelect;
//# sourceMappingURL=MultiSelectFieldSortSelect.js.map